import { actionGenerator } from '../../utils/store/actionGenerator';
import { ITypedReduxAction } from '../../types/redux';

export enum EFavoritesActionTypes {
  ChangeFavoriteState = 'favorites/changeFavoriteState',
  ChangeMotivationPopupState = 'favorites/changeMotivationPopupState',
}

export type TChangeFavoriteState = ITypedReduxAction<EFavoritesActionTypes.ChangeFavoriteState, boolean>;
export type TChangeFavoriteStateAction = (payload: boolean) => TChangeFavoriteState;

export const changeFavoriteState: TChangeFavoriteStateAction = actionGenerator<
  EFavoritesActionTypes.ChangeFavoriteState,
  boolean
>(EFavoritesActionTypes.ChangeFavoriteState);

export type TChangeMotivationPopupState = ITypedReduxAction<EFavoritesActionTypes.ChangeMotivationPopupState, boolean>;
export type TChangeMotivationPopupStateAction = (payload: boolean) => TChangeMotivationPopupState;

export const changeMotivationPopupState: TChangeMotivationPopupStateAction = actionGenerator<
  EFavoritesActionTypes.ChangeMotivationPopupState,
  boolean
>(EFavoritesActionTypes.ChangeMotivationPopupState);

export type TFavoritesActions = TChangeFavoriteState | TChangeMotivationPopupState;
